// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Weekly Performance Bar Styles */

.weekly-performance-bar {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  min-width: 200px;
}

.weekly-performance-bar--empty {
  padding: 12px;
  display: flex;
  align-items: center;
}

.weekly-performance-bar__labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.weekly-performance-bar__container {
  width: 100%;
  position: relative;
}

.weekly-performance-bar__background {
  width: 100%;
  height: 8px;
  background-color: var(--color-grey-91);
  background-color: var(--color-grey-91);
  border-radius: 4px;
  position: relative;
  overflow: visible;
}

.weekly-performance-bar__fill {
  height: 100%;
  background-color: var(--color-status-positive-80);
  background-color: var(--color-status-positive-80);
  border-radius: 4px;
  transition: width 0.3s ease-in-out;
  position: relative;
  z-index: 1;
}

.weekly-performance-bar__planned-marker {
  position: absolute;
  top: -2px;
  height: 12px;
  width: 2px;
  transform: translateX(-50%);
  z-index: 2;
}

.weekly-performance-bar__planned-line {
  width: 2px;
  height: 100%;
  background-color: var(--color-primary-idel);
  background-color: var(--color-primary-idel);
  border-radius: 1px;
}

.weekly-performance-bar__value-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-top: 4px;
}

.weekly-performance-bar__planned-label {
  position: absolute;
  transform: translateX(-50%);
}
`, "",{"version":3,"sources":["webpack://./app/components/dashboard/AllFarmView/WeeklyPerformanceBar.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iDAAiD;EACjD,iDAAiD;EACjD,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B","sourcesContent":["/* Weekly Performance Bar Styles */\n\n.weekly-performance-bar {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  min-width: 200px;\n}\n\n.weekly-performance-bar--empty {\n  padding: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.weekly-performance-bar__labels {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n.weekly-performance-bar__container {\n  width: 100%;\n  position: relative;\n}\n\n.weekly-performance-bar__background {\n  width: 100%;\n  height: 8px;\n  background-color: var(--color-grey-91);\n  background-color: var(--color-grey-91);\n  border-radius: 4px;\n  position: relative;\n  overflow: visible;\n}\n\n.weekly-performance-bar__fill {\n  height: 100%;\n  background-color: var(--color-status-positive-80);\n  background-color: var(--color-status-positive-80);\n  border-radius: 4px;\n  transition: width 0.3s ease-in-out;\n  position: relative;\n  z-index: 1;\n}\n\n.weekly-performance-bar__planned-marker {\n  position: absolute;\n  top: -2px;\n  height: 12px;\n  width: 2px;\n  transform: translateX(-50%);\n  z-index: 2;\n}\n\n.weekly-performance-bar__planned-line {\n  width: 2px;\n  height: 100%;\n  background-color: var(--color-primary-idel);\n  background-color: var(--color-primary-idel);\n  border-radius: 1px;\n}\n\n.weekly-performance-bar__value-labels {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  margin-top: 4px;\n}\n\n.weekly-performance-bar__planned-label {\n  position: absolute;\n  transform: translateX(-50%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
